import {AppStartListening} from "../../store";
import {ListenerEffectAPI, Unsubscribe} from "@reduxjs/toolkit";
import {findSelectedClub} from "../clubs/slice";
import {loadClubCaddies} from "./async_actions";
import {findSelectedCaddieFromUrl} from "./slice";

const loadCaddiesForSelectedClub = async (_: any, listenerApi: ListenerEffectAPI<any, any>) => {
    listenerApi.dispatch(loadClubCaddies())
}

const findSelectedCaddie = async (_: any, listenerApi: ListenerEffectAPI<any, any>) => {
    listenerApi.dispatch(findSelectedCaddieFromUrl())
}

export function setupPostRoundListeners(startListening: AppStartListening): Unsubscribe {
    const subscriptions: any[] = [
        startListening({
            actionCreator: findSelectedClub,
            effect: loadCaddiesForSelectedClub,
        }),
        startListening({
            actionCreator: loadClubCaddies.fulfilled,
            effect: findSelectedCaddie,
        }),
    ]

    return () => {
        subscriptions.forEach((unsubscribe) => unsubscribe())
    }
}